import { StepName } from '|/app/services';
import type { Summary } from '|/app/services';

const STEP_TITLE_OVERRIDES: Partial<Record<StepName, string>> = {
  [StepName.BuyerIdentity]: 'Identity',
  [StepName.Payment]: 'Payment method'
};

function toSentenceCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

function getScheduleTitle(summary: Summary | null): string {
  const isDelivery = summary?.transfer?.deliveryType?.toLowerCase().includes('delivery');
  return isDelivery ? 'Schedule delivery' : 'Schedule pickup';
}

export function transformCheckoutStepTitle(
  stepId: StepName,
  stepName: string,
  summary: Summary | null
): string {
  if (stepId === StepName.Schedule) return getScheduleTitle(summary);

  const override = STEP_TITLE_OVERRIDES[stepId];
  if (override) return override;

  return toSentenceCase(stepName);
}
